import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Avatar, AvatarImage, AvatarFallback } from '@src/design-system/avatar';
import { DropdownMenuItem } from '@src/design-system/dropdown-menu';
import { cn } from '@src/design-system/helpers';
import { RadioIndicator } from '@src/design-system/radio';

import type { TOrganization } from '@src/shared/types/organization';

export function ProfileMenuOrganizationItem({
  organization,
}: {
  organization: TOrganization;
}) {
  const navigate = useNavigate();
  const { organizationSlug: orgSlugParam } = useParams();
  const { pathname } = useLocation();

  const orgSlugSelected = organization.slug;
  const isActive = orgSlugSelected === orgSlugParam;

  const handleOrgClick = () => {
    if (orgSlugSelected === orgSlugParam) return;

    const newPath = pathname.replace(
      `/${orgSlugParam}/`,
      `/${orgSlugSelected}/`
    );

    navigate(newPath, { replace: true });
  };

  return (
    <DropdownMenuItem
      className={cn(
        isActive && 'bg-primary-50 border w-full border-primary-200'
      )}
      onClick={handleOrgClick}
    >
      <Avatar className='size-10 border border-primary-100'>
        <AvatarImage
          className='object-contain'
          src={organization.avatar}
        />
        <AvatarFallback colorId={organization.id}>
          {organization.name[0]}
        </AvatarFallback>
      </Avatar>

      <div className='flex capitalize flex-col truncate w-[90%] items-start text-gray-800 font-medium text-sm'>
        <span
          className='truncate block w-full'
          title={organization.name}
        >
          {organization.name}
        </span>
        <span className='text-gray-600 text-xs font-normal'>
          {organization.country.name}
        </span>
      </div>

      <RadioIndicator checked={isActive} />
    </DropdownMenuItem>
  );
}
